/**
 * Deep links for CRM lists — must stay aligned with `ClientListCreateView` query params
 * and the Leads page URL sync logic.
 */

export type LeadsPipelineQuery = {
  follow_up?: 'today' | 'overdue';
  temperature?: 'hot' | 'warm' | 'cold';
  /** Server-side attention sort (hot first, then next follow-up). */
  sort?: 'attention';
  workflow_status?: string;
  /** Contacts with a demo scheduled this calendar week (backend `demo_week`). */
  demo_week?: boolean;
  /** Quick capture / incomplete records (backend `requires_review=1`). */
  requires_review?: boolean;
  /** Open pipeline profile panel for this client id (Leads page handles this). */
  pipeline_contact?: string;
  /** List ordering, e.g. `-last_contacted` — must match backend `ordering_fields`. */
  ordering?: string;
};

/** Opens the Leads page and triggers the Quick Capture modal (see Leads page). */
export function leadsQuickCaptureUrl(): string {
  return '/leads?quickCapture=true';
}

/** Build `/leads` URL with pipeline filters (stage=lead is implied by the page). */
export function leadsPipelineUrl(q: LeadsPipelineQuery = {}): string {
  const sp = new URLSearchParams();
  if (q.follow_up) sp.set('follow_up', q.follow_up);
  if (q.temperature) sp.set('temperature', q.temperature);
  if (q.sort === 'attention') sp.set('sort', 'attention');
  if (q.workflow_status) sp.set('workflow_status', q.workflow_status);
  if (q.demo_week) sp.set('demo_week', '1');
  if (q.requires_review) sp.set('requires_review', '1');
  if (q.pipeline_contact) sp.set('pipeline_contact', q.pipeline_contact);
  if (q.ordering) sp.set('ordering', q.ordering);
  const s = sp.toString();
  return s ? `/leads?${s}` : '/leads';
}

export function prospectsUrl(): string {
  return '/prospects';
}

export function clientsUrl(): string {
  return '/clients';
}

/** After CSV import of leads — show newest / attention-friendly view. */
export function leadsPostImportUrl(): string {
  return leadsPipelineUrl({ sort: 'attention' });
}
